<ng-container [ngSwitch]="column.type">
  <div class="flex justify-content-between min-w-full">
    <div class="flex align-items-center justify-content-center">
      {{
        "field:" +
          (column.header
            ? (column.header  | mxFirstLetterOperation)
            : (column.field | mxFirstLetterOperation)) | i18next
      }}
      <p-sortIcon [field]="column.field"></p-sortIcon>
    </div>
    <div class="flex align-items-center justify-content-center">
      <ng-container *ngSwitchCase="columnType.Text">
        <mx-table-column-filter
          [type]="'text'"
          [field]="column.field"
        ></mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.Id">
        <mx-table-column-filter
          *ngIf="!column.betweenValues"
          [type]="'numeric'"
          [field]="column.field"
        ></mx-table-column-filter>
        <mx-table-column-filter
          *ngIf="column.betweenValues"
          [field]="column.field"
          [matchMode]="filterMatchMode.BETWEEN"
          [useFilterTemplate]="true"
          [showApplyButton]="false"
        >
          <ng-template #filterTemplateRef let-value let-filter="filterCallback">
            <mx-slider
              [(ngModel)]="numberBetweenValues"
              (onSlideEnd)="filter($any($event).values)"
              [min]="column.betweenValues[0]"
              [max]="column.betweenValues[1]"
            >
            </mx-slider>
          </ng-template>
        </mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.Number">
        <mx-table-column-filter
          *ngIf="!column.betweenValues"
          [type]="'numeric'"
          [field]="column.field"
        ></mx-table-column-filter>
        <mx-table-column-filter
          *ngIf="column.betweenValues"
          [field]="column.field"
          [matchMode]="filterMatchMode.BETWEEN"
          [useFilterTemplate]="true"
          [showApplyButton]="false"
        >
          <ng-template #filterTemplateRef let-value let-filter="filterCallback">
            <mx-slider
              [ngModel]="value ? value : numberBetweenValues"
              (onSlideEnd)="filter($any($event).values)"
              [min]="column.betweenValues[0]"
              [max]="column.betweenValues[1]"
            >
            </mx-slider>
          </ng-template>
        </mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.Boolean">
        <mx-table-column-filter
          [type]="'boolean'"
          [field]="column.field"
        ></mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.Date">
        <mx-table-column-filter
          [type]="'date'"
          [field]="column.field"
        ></mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.DateTime">
        <mx-table-column-filter
          [type]="'date'"
          [field]="column.field"
        ></mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.Enum">
        <mx-table-column-filter
          *ngIf="!column.isMulti"
          [field]="column.field"
          [matchMode]="filterMatchMode.EQUALS"
          [useFilterTemplate]="true"
          [showApplyButton]="false"
        >
          <ng-template #filterTemplateRef let-value let-filter="filterCallback">
            <mx-dropdown
              [ngModel]="value"
              [options]="
                column.enum
                  | mxEnumAsArray: column.enumName:column.enumOperationValues
              "
              (onChange)="filter($any($event).value)"
              [useSelectedItemTemplate]="true"
              [useItemTemplate]="true"
            >
              <ng-template #selectedItemTemplateRef let-value>
                {{ value.label | i18next }}
              </ng-template>
              <ng-template #itemTemplateRef let-value>
                {{ value.label | i18next }}
              </ng-template>
            </mx-dropdown>
          </ng-template>
        </mx-table-column-filter>
        <mx-table-column-filter
          *ngIf="column.isMulti"
          [field]="column.field"
          [matchMode]="filterMatchMode.IN"
          [useFilterTemplate]="true"
          [showApplyButton]="false"
        >
          <ng-template #filterTemplateRef let-value let-filter="filterCallback">
            <mx-multi-select
              [ngModel]="value"
              [options]="
                column.enum
                  | mxEnumAsArray: column.enumName:column.enumOperationValues
              "
              (onChange)="
                filter(
                  $any($event).value?.length !== 0 ? $any($event).value : null
                )
              "
              [style]="{ minWidth: '200px' }"
              [panelStyle]="{ 'z-index': 19100 }"
              [autoZIndex]="false"
            >
            </mx-multi-select>
          </ng-template>
        </mx-table-column-filter>
      </ng-container>
      <ng-container *ngSwitchCase="columnType.RemoteSource">
        <mx-table-column-filter
          *ngIf="!column.isMulti"
          [field]="column.field"
          [matchMode]="filterMatchMode.EQUALS"
          [useFilterTemplate]="true"
          [showApplyButton]="false"
        >
          <ng-template #filterTemplateRef let-value let-filter="filterCallback">
            <mx-dropdown
              [ngModel]="value"
              [options]="remoteSource"
              (onChange)="filter($any($event).value)"
            >
            </mx-dropdown>
          </ng-template>
        </mx-table-column-filter>
        <mx-table-column-filter
          #remoteSourceMultiSelect
          *ngIf="column.isMulti"
          [field]="column.field"
          [matchMode]="filterMatchMode.IN"
          [useFilterTemplate]="true"
          [showApplyButton]="false"
        >
          <ng-template #filterTemplateRef let-value let-filter="filterCallback">
            <mx-multi-select
              [ngModel]="value"
              [options]="remoteSource"
              (onChange)="
                filter(
                  $any($event).value?.length !== 0 ? $any($event).value : null
                )
              "
              [style]="{ minWidth: '200px' }"
              [useItemTemplate]="true"
              [appendTo]="'remoteSourceMultiSelect'"
            >
            </mx-multi-select>
          </ng-template>
        </mx-table-column-filter>
      </ng-container>

      <ng-container *ngSwitchDefault> </ng-container>
    </div>
  </div>
</ng-container>
